export default __webpack_public_path__ + "static/jurassic-588d519119e3f5b87809905b19dbd2f8.jpg";